import _ from 'lodash';
import { navigate } from 'src/workspace/utils';

export const getReferralFilters = (customFilter) =>
  (customFilter || []).reduce((acc, f) => {
    acc[f.path] = _.uniq([...(acc[f.path] ?? []), ...f.value]);
    return acc;
  }, {});

export const getReferralDropdownParams = (
  customFilter: Array<{ value: Array<string>; path: string }>,
  source: string,
  searchText?: string,
) => ({
  filters: JSON.stringify(getReferralFilters(customFilter)),
  source,
  search_text: searchText,
});

export const getReferredModuleCode = (
  start_state,
  modules: Array<{ start_state: string; code: string }> = [],
) => {
  const module = modules.find((m) => m?.start_state === start_state);
  return module?.code;
};

export const referralOnclick = (version, source, code, config) => {
  if (version === 'webRevyre') {
    window.location.hash = `/revyre/workflow/${source}/details/${code}`;
  } else {
    const module = (config.lead_modules || []).find(
      (m) => m?.start_state === source,
    );
    navigate('leads', { module: module.code, leadId: code });
  }
};
